exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n\n  /*colors named by https://www.color-blindness.com/color-name-hue/*/\n\n  /*shadow*/\n\n  /*z-index*/\n\n  /*transition*/\n\n  /*radius*/\n\n  /*chat*/\n}\n\n._1dIWE8K {\n  position: relative;\n}\n\n._1JJuski {\n    margin: 0 auto 40px;\n  }\n\n._2729IBV {\n    margin: 0 0 24px;\n  }\n\n.ia4FOO4 {\n    width: 100%;\n  }\n", ""]);
// Exports
exports.locals = {
	"RegisterForm": "_1dIWE8K",
	"RegisterForm__photo": "_1JJuski",
	"RegisterForm__field": "_2729IBV",
	"RegisterForm__submit": "ia4FOO4"
};